import { Stack, Skeleton, Box } from '@mui/material';

function PageLoader() {
  return (
    <Stack spacing={2.5}>
      {/* Header row */}
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <Skeleton
            variant="rectangular"
            width={4} height={28}
            sx={{ borderRadius: '2px', bgcolor: 'rgba(79,70,229,0.15)' }}
          />
          <Skeleton
            variant="rectangular"
            width={180} height={36}
            sx={{ borderRadius: '8px', bgcolor: 'rgba(79,70,229,0.07)' }}
          />
        </Stack>
        <Skeleton
          variant="rectangular"
          width={110} height={40}
          sx={{ borderRadius: '10px', bgcolor: 'rgba(79,70,229,0.1)' }}
        />
      </Stack>

      {/* Search / filter card */}
      <Skeleton
        variant="rectangular"
        width="100%" height={220}
        sx={{ borderRadius: '16px', bgcolor: 'rgba(79,70,229,0.05)' }}
      />

      {/* Table */}
      <Box sx={{ borderRadius: '16px', overflow: 'hidden', border: '1px solid #E2E8F0' }}>
        {/* Toolbar */}
        <Skeleton
          variant="rectangular"
          width="100%" height={60}
          sx={{ borderRadius: 0, bgcolor: '#F8FAFC' }}
        />
        {/* Rows */}
        {[0, 1, 2, 3, 4, 5].map((i) => (
          <Stack
            key={i}
            direction="row"
            alignItems="center"
            spacing={2}
            sx={{
              px: 2, py: 1.5,
              borderBottom: '1px solid #F1F5F9',
              bgcolor: i % 2 === 0 ? '#fff' : '#FAFAFA',
            }}
          >
            <Skeleton variant="circular" width={28} height={28} sx={{ flexShrink: 0, bgcolor: 'rgba(79,70,229,0.06)' }} />
            <Skeleton variant="text" height={20} sx={{ flex: 1.5, bgcolor: 'rgba(79,70,229,0.05)' }} />
            <Skeleton variant="text" height={20} sx={{ flex: 1, bgcolor: 'rgba(79,70,229,0.05)' }} />
            <Skeleton variant="text" height={20} sx={{ flex: 0.6, bgcolor: 'rgba(79,70,229,0.05)' }} />
            <Skeleton variant="rounded" width={60} height={22} sx={{ borderRadius: '6px', bgcolor: 'rgba(16,185,129,0.08)' }} />
            <Skeleton variant="circular" width={28} height={28} sx={{ flexShrink: 0, bgcolor: 'rgba(79,70,229,0.06)' }} />
          </Stack>
        ))}
      </Box>
    </Stack>
  );
}

export default PageLoader;
